<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
    :souqPage="true"
  >
    <template slot="add">
      <FormItem>
        <Upload :before-upload="handleUpload" action="/" accept=".xlsx,.xls">
          <Button type="primary" icon="md-add">{{ $t("import") }}</Button>
        </Upload>
      </FormItem>
    </template>
    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <template v-if="crudText == 'add'">
          <common-exl
            :tableDetails="tableData"
            :exlTitle="exlTitle"
          ></common-exl>
        </template>
        <template v-else>
          <common-souq :dataDetails="dataDetails"></common-souq>
        </template>
      </template>
    </div>
  </common>
</template>

<script>
import { getSouq, add, del, getDetails } from "@/api/souq/new";
import common from "_c/common-body";
import commonExl from "_c/common-exl";
import commonSouq from "_c/common-souq";
import basic from "@/utils/basic";
import nodata from "@/utils/nodata";
import boxMes from "@/utils/message";

// import excel from "@/libs/excel";
export default {
  name: "city",
  components: {
    common,
    commonExl,
    commonSouq
  },
  data() {
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: ""
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        city_name: [
          {
            required: true,
            message: "city_name cannot be empty",
            trigger: "blur"
          },
          {
            max: 55,
            message: "Please enter maximum length 55",
            trigger: "blur"
          }
        ],
        city_code: [
          {
            required: true,
            message: "city_code cannot be empty",
            trigger: "blur"
          },
          {
            max: 255,
            message: "Please enter maximum length 255",
            trigger: "blur"
          }
        ],
        zip_code: [
          {
            required: true,
            message: "zip_code cannot be empty",
            trigger: "blur"
          }
        ],
        country_id: [
          {
            required: true,
            type: "number",
            message: "Please select the country",
            trigger: "change"
          }
        ],
        is_enable: [
          {
            required: true,
            type: "number",
            message: "Please select the status",
            trigger: "change"
          }
        ]
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      objUserClient: {},
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      tableData: []
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("amazon"),
        key: "amazon_id",
        align: "center",
        minWidth: 140,
        tooltip: true
      });
      columns.push({
        title: this.$t("souqNum"),
        key: "souq_id",
        align: "center",
        minWidth: 130,
        tooltip: true
      });
      columns.push({
        title: this.$t("order_number"),
        key: "airway_bill_number",
        align: "center",
        minWidth: 140,
        tooltip: true,
        render: (h, params) => {
          return h("div", [
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small"
                },
                style: {
                  marginRight: "5px"
                },
                on: {
                  click: () => {
                    this.crudClick(params.row, "show");
                  }
                }
              },
              params.row.airway_bill_number
            )
          ]);
        }
      });
      columns.push({
        title: this.$t("createTime"),
        key: "create_time",
        align: "center",
        minWidth: 170
      });
      columns.push({
        title: this.$t("clientName"),
        key: "client_name",
        align: "center",
        minWidth: 110
      });
      columns.push({
        title: this.$t("orderType"),
        key: "status",
        align: "center",
        minWidth: 110
      });
      // columns.push({
      //   title: this.$t("status_operator"),
      //   key: "operator_id",
      //   align: "center",
      //   minWidth: 110,
      // });
      columns.push({
        title: this.$t("invoiceWeight"),
        key: "weight",
        align: "center",
        minWidth: 140
      });
      columns.push({
        title: this.$t("invoicePCS"),
        key: "pcs",
        align: "center",
        minWidth: 100
      });
      columns.push({
        title: this.$t("store_name"),
        key: "store_name",
        align: "center",
        minWidth: 120,
        tooltip: true
      });
      columns.push({
        title: this.$t("courier"),
        key: "courier",
        align: "center",
        minWidth: 110
      });
      columns.push({
        title: this.$t("site_name"),
        key: "site_name",
        align: "center",
        minWidth: 110
      });
      columns.push({
        title: this.$t("label_url"),
        key: "label_url",
        align: "center",
        minWidth: 110
      });
      columns.push({
        title: this.$t("order_desc"),
        key: "remarks",
        align: "center",
        tooltip: true,
        minWidth: 110
      });
      // columns.push({
      //   title: this.$t("operation"),
      //   slot: "souqOperation",
      //   align: "center",
      //   minWidth: 280,
      // });
      return columns;
    },
    exlTitle() {
      let columns = [];
      columns.push({
        title: this.$t("exlType"),
        key: "status",
        align: "center",
        minWidth: 100,
        filters: [
          {
            label: this.$t("success"),
            value: this.$t("success")
          },
          {
            label: this.$t("error"),
            value: this.$t("error")
          }
        ],
        filterMultiple: false,
        filterMethod(value, row) {
          return row.status.indexOf(value) > -1;
        },
        render: (h, params) => {
          return h("div", [
            h(
              "span",
              {
                style: {
                  color:
                    params.row.status == this.$t("ready")
                      ? "#57a3f3"
                      : params.row.status == this.$t("success")
                      ? "#19be6b"
                      : "#ed4014"
                }
              },
              params.row.status
            )
          ]);
        }
      });
      columns.push({
        title: this.$t("order_number"),
        key: "airway_bill_number",
        align: "center",
        minWidth: 140,
        render: (h, params) => {
          if (params.row.airway_bill_number) {
            return h("div", [
              h(
                "Tooltip",
                {
                  props: { placement: "bottom" }
                },
                [
                  h(
                    "span",
                    {
                      style: {
                        color:
                          params.row.status == this.$t("ready")
                            ? "#57a3f3"
                            : params.row.status == this.$t("success")
                            ? "#19be6b"
                            : "#ed4014",
                        display: "inline-block",
                        width: params.column._width * 0.85 + "px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }
                    },
                    params.row.airway_bill_number
                  ),
                  h(
                    "span",
                    {
                      slot: "content",
                      style: { whiteSpace: "normal", wordBreak: "break-all" }
                    },
                    params.row.airway_bill_number
                  )
                ]
              )
            ]);
          }
        }
      });
      columns.push({
        title: this.$t("amazon"),
        key: "ShipperRef",
        align: "center",
        minWidth: 140,
        tooltip: true,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.ShipperRef
            },
            on: {
              input: val => {
                this.tableData[params.index].ShipperRef = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("souqNum"),
        key: "souq_order_id",
        align: "center",
        minWidth: 130,
        tooltip: true,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.souq_order_id
            },
            on: {
              input: val => {
                this.tableData[params.index].souq_order_id = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("noofpieces"),
        key: "noofpieces",
        align: "center",
        minWidth: 130,
        tooltip: true,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.noofpieces
            },
            on: {
              input: val => {
                this.tableData[params.index].noofpieces = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("totalWeight"),
        key: "TotalWeight",
        align: "center",
        minWidth: 140,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.TotalWeight
            },
            on: {
              input: val => {
                this.tableData[params.index].TotalWeight = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("invoiceWeight"),
        key: "weight",
        align: "center",
        minWidth: 140,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.weight
            },
            on: {
              input: val => {
                this.tableData[params.index].weight = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("invoicePCS"),
        key: "PCS",
        align: "center",
        minWidth: 100,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.PCS
            },
            on: {
              input: val => {
                this.tableData[params.index].PCS = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("store_name"),
        key: "store_name",
        align: "center",
        minWidth: 120,
        tooltip: true,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.store_name
            },
            on: {
              input: val => {
                this.tableData[params.index].store_name = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("courier"),
        key: "courier",
        align: "center",
        minWidth: 110,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.courier
            },
            on: {
              input: val => {
                this.tableData[params.index].courier = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("site_name"),
        key: "site_name",
        align: "center",
        minWidth: 110,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.site_name
            },
            on: {
              input: val => {
                this.tableData[params.index].site_name = val;
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("order_desc"),
        key: "Description",
        align: "center",
        tooltip: true,
        minWidth: 110,
        render: (h, params) => {
          return h("Input", {
            props: {
              value: params.row.Description
            },
            on: {
              input: val => {
                this.tableData[params.index].Description = val;
              }
            }
          });
        }
      });
      return columns;
    }
  },
  mounted() {
    this.objUserClient = basic.objUserClient();
    this.getList(this.searchFrom);
  },
  methods: {
    handleUpload(file) {
      const fileExt = file.name
        .split(".")
        .pop()
        .toLocaleLowerCase();
      if (fileExt === "xlsx" || fileExt === "xls") {
        this.readFile(file);
        this.file = file;
      } else {
        this.$Notice.warning({
          title: this.$t("files") + this.$t("type") + this.$t("wrong"),
          desc: this.$t("files") + file.name + this.$t("not_excel_tip")
        });
      }
      return false;
    },
    readFile(file) {
      let _this = this;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadstart = e => {
        this.uploadLoading = true;
        this.tableLoading = true;
        this.showProgress = true;
      };
      reader.onprogress = e => {
        this.progressPercent = Math.round((e.loaded / e.total) * 100);
      };
      reader.onerror = e => {
        this.$Message.error(this.$t("files") + this.$t("read_error"));
      };
      reader.onload = e => {
        const data = e.target.result;
        const { header, results } = excel.read(data, "array");
        //const tableTitle = header.map(item => { return { title: item, key: item } })
        // 以下为处理数据
        let arr = [];
        results.map(v => {
          v.status = this.$t("ready");
          let obj = {};
          _this.exlTitle.forEach(t => {
            obj[t["key"]] = v[t["key"]];
          });
          arr.push(obj);
        });
        arr.splice(0, 1);
        _this.tableData = arr;
        this.crudText = "add";
        this.isshowModal = true;
        this.width = 1600;
        this.titleModal = this.$t("add");
        this.unChange = false;
      };
    },
    changeBindModal(val) {
      if (!val) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          if (this.crudText == "show") {
            this.dataDetails = {};
            return;
          }
          this.getList(this.searchFrom);
        }
      } else {
        if (this.crudText === "delete") {
          this.deleteList(this.delId);
        } else {
          this.confirm();
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          if (this.crudText == "show") {
            this.dataDetails = {};
            return;
          }
          this.getList(this.searchFrom);
        }
      }
    },
    confirm() {
      this.addList();
    },
    crudClick(item, text) {
      this.objCountry = basic.objDictCountry();
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = false;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
            this.width = 1200;
          }
          this.dataDetails = {};
          this.preForm = {};
          this.getDetailsList(item.id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then(res => {
          delete res.data.payload.country;
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getList(data) {
      this.loading = true;
      getSouq(data)
        .then(res => {
          if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows.map(item => {
            let client = nodata.noData(
              basic.objUserClient(),
              item.client_id,
              "client"
            );
            item.client_name = client.name;
            return item;
          });
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    addList() {
      let orders = this.tableData;
      add({ orders: orders }).then(res => {
        res.data.payload.forEach((item, index) => {
          if (item.status) {
            this.tableData[index].status = this.$t("success");
            this.tableData[index].airway_bill_number = item.airway_bill_number;
            return;
          } else {
            this.tableData[index].airway_bill_number = item.errList;
            this.tableData[index].status = this.$t("error");
          }
        });
        // boxMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then(res => {
        boxMes.alertMes(res, this);
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
